export function getSiblings(elem) {
	return Array.prototype.filter.call(elem.parentNode.children, function (sibling) {
		return sibling !== elem;
	});
}

export function scrollPageTo(to, duration = 500, offset = 0, element = document.scrollingElement) {
	//t = current time
	//b = start value
	//c = change in value
	//d = duration
	const easeInOutQuad = function (t, b, c, d) {
		t /= d / 2;
		if (t < 1) return (c / 2) * t * t + b;
		t--;
		return (-c / 2) * (t * (t - 2) - 1) + b;
	};

	return new Promise((resolve, reject) => {
		// const element = document.scrollingElement;

		if (typeof to === 'string') {
			to = document.querySelector(to) || reject();
		}

		if (typeof to !== 'number') {
			to = to.getBoundingClientRect().top + element.scrollTop;
		}

		to = to + offset;

		let start = element.scrollTop,
			change = to - start,
			currentTime = 0,
			increment = 20;

		const animateScroll = function () {
			currentTime += increment;
			let val = easeInOutQuad(currentTime, start, change, duration);
			element.scrollTop = val;
			if (currentTime < duration) {
				requestAnimationFrame(animateScroll);
			} else {
				resolve();
			}
		};
		animateScroll();
	});
}

export function isInViewport(elem) {
	const bounding = elem.getBoundingClientRect();
	return (
		bounding.top >= 0 &&
		bounding.left >= 0 &&
		bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
}

export function isElement(element) {
	return element instanceof Element || element instanceof HTMLDocument;
}

export function getFullHeight(element) {
	const height = element.offsetHeight;
	const style = window.getComputedStyle ? getComputedStyle(element, null) : element.currentStyle;
	const marginTop = parseInt(style.marginTop) || 0;
	const marginBottom = parseInt(style.marginBottom) || 0;

	return height + marginTop + marginBottom;
}

export function normalize(value, min, max) {
	return (value - min) / (max - min);
}

export function iOS() {
	return (
		['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
		// iPad on iOS 13 detection
		(navigator.userAgent.includes('Mac') && 'ontouchend' in document)
	);
}

export function loadCSS(url) {
	return new Promise((resolve, reject) => {
		const filename = url.split('/').pop();
		const styleTags = document.head.querySelectorAll('link[rel="stylesheet"]');
		let styleExists = false;

		styleTags.forEach((tag) => {
			if (tag.href && tag.href.includes(filename)) {
				styleExists = true;
			}
		});

		if (styleExists) {
			resolve();
			return;
		}

		const link = document.createElement('link');
		link.rel = 'stylesheet';
		link.href = url;
		link.onload = () => resolve();
		link.onerror = () => reject(new Error(`CSS load failed: ${url}`));
		document.head.appendChild(link);
	});
}

export function lerp(a, b, n) {
	return (1 - n) * a + n * b;
}

// Map number x from range [a, b] to [c, d]
export function map(x, a, b, c, d) {
	return ((x - a) * (d - c)) / (b - a) + c;
}

export function getViewPercentage(element) {
	const viewport = {
		top: window.scrollY,
		bottom: window.scrollY + window.innerHeight,
	};

	const elementBoundingRect = element.getBoundingClientRect();
	const elementPos = {
		top: elementBoundingRect.y + window.scrollY,
		bottom: elementBoundingRect.y + elementBoundingRect.height + window.scrollY,
	};

	if (viewport.top > elementPos.bottom || viewport.bottom < elementPos.top) {
		return 0;
	}

	// Element is fully within viewport
	if (viewport.top < elementPos.top && viewport.bottom > elementPos.bottom) {
		return 100;
	}

	// Element is bigger than the viewport
	if (elementPos.top < viewport.top && elementPos.bottom > viewport.bottom) {
		return 100;
	}

	const elementHeight = elementBoundingRect.height;
	let elementHeightInView = elementHeight;

	if (elementPos.top < viewport.top) {
		elementHeightInView = elementHeight - (window.scrollY - elementPos.top);
	}

	if (elementPos.bottom > viewport.bottom) {
		elementHeightInView = elementHeightInView - (elementPos.bottom - viewport.bottom);
	}

	const percentageInView = (elementHeightInView / window.innerHeight) * 100;

	return Math.round(percentageInView);
}

export function selectMatchingVideoSource(video, type) {
	return new Promise((resolve) => {
		if (!video) {
			return;
		}

		const type = type;

		const rect = video.getBoundingClientRect();

		const clientWidth = rect.width * window.devicePixelRatio;
		const clientHeight = rect.height * window.devicePixelRatio;
		const clientRatio = clientWidth / clientHeight;

		const videoWidth = video.getAttribute('width');
		const videoHeight = video.getAttribute('height');
		const videoRatio = videoWidth / videoHeight;

		// from 0 to 1 (0.5 - 50%, 1 = 100%)
		const quality = video.getAttribute('data-quality') ?? 1;

		let width = '';
		if (clientRatio > videoRatio) {
			width = clientWidth * quality;
		} else {
			width = clientHeight * videoRatio * quality;
		}

		let matchedSource = null;
		let prevDiff = 999999;

		// Loop over all video sources
		const sources = video.querySelectorAll('source');
		const totalSourceCount = sources.length;
		let checkedSourcesCount = 0;

		const checkSources = new Promise((resolve, reject) => {
			Array.from(sources).forEach((source) => {
				// Get source type

				let sourceType = source.dataset.sourcetype;
				if (sourceType != type) {
					console.log('skipping source, not the correct type..');
					return;
				}

				// Get source resolution (provided by data attribute)
				let sourceWidth = source.dataset.sourcewidth;

				// Compare source resolution to video element width
				let currentDiff = sourceWidth - width;
				if (currentDiff <= 0) {
					currentDiff = currentDiff * -1;
				}
				if (currentDiff <= prevDiff) {
					matchedSource = source;
				}
				prevDiff = currentDiff;

				setTimeout(() => {
					checkedSourcesCount++;
					if (checkedSourcesCount >= totalSourceCount) {
						resolve('Checked All Sources');
					}
				}, 0);
			});
		});

		checkSources.then(() => {
			if (!matchedSource) {
				return;
			}
			if (video.src != matchedSource.src) {
				video.pause();
				video.src = matchedSource.src;
				resolve();
			}
		});
	});
}
